import Container from './DeviationPopupDropZone.container';
import DeviationPopupDropZone from './DeviationPopupDropZone';

export default Container(DeviationPopupDropZone);
